<template>
   <div class=" w-[100px] h-[70px] p-4 flex-row 2-40">
      <img src="@/assets/Images/Logo.svg" onerror="this.style.display='none'">
   </div>
</template>

<script>
export default {

}
</script>
